import moment from "moment";

export const sortTestData = (audioData, sortBy) => {
  let myAudio = audioData;
  if (sortBy === "name") {
    myAudio = audioData.sort(function (a, b) {
      if (a.test_name.toLowerCase() < b.test_name.toLowerCase()) {
        return -1;
      } else if (a.test_name.toLowerCase() > b.test_name.toLowerCase()) {
        return 1;
      } else {
        return 0;
      }
    });
  }
  if (sortBy === "totalTime") {
    myAudio = audioData.sort(function (a, b) {
      if (parseInt(a.total_time) < parseInt(b.total_time)) {
        return -1;
      } else if (parseInt(a.total_time) > parseInt(b.total_time)) {
        return 1;
      } else {
        return 0;
      }
    });
  }
  if (sortBy === "latest") {
    myAudio = audioData.sort(function (a, b) {
      // const completeTime = a.complete_date.split(" ");
      let dataA = moment(a.complete_date).format("x");
      let dataB = moment(b.complete_date).format("x");
      dataA = dataA === "Invalid date" ? moment().format("x") : dataA;
      dataB = dataB === "Invalid date" ? moment().format("x") : dataB;
      // console.log();
      if (parseInt(dataA) > parseInt(dataB)) {
        return -1;
      } else if (parseInt(dataA) < parseInt(dataB)) {
        return 1;
      } else {
        return 0;
      }
    });
  }
  return myAudio;
};


